import { render, staticRenderFns } from "./PictimeBar.vue?vue&type=template&id=c873c6e6"
import script from "./PictimeBar.vue?vue&type=script&lang=js"
export * from "./PictimeBar.vue?vue&type=script&lang=js"
import style0 from "./PictimeBar.vue?vue&type=style&index=0&id=c873c6e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports